import "../tool.js";
/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements. Most tools just pass the component context to their templates, so that's the default
 *  tool.render - by default updates the tool element with markup generated by tool template, overrid for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext and update. update is
 *  - identical to render by default, but you can override it. the update lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context value, you update your view there.
 */

(function (Event) {
  "use strict";

  Sparkle.PageBuilder.Tool(
    (function () {
      var document = window.document, //set this here for testing only
        $resizeElem,
        resizing = false,
        $body = jQuery(window.document.body), //set for testing
        initialX,
        containerWidth;

      jQuery(function () {
        var previewElement = window.document.getElementById("page-preview");
        jQuery(previewElement).on("load", function () {
          document = previewElement.contentWindow.document;
          $body = jQuery(document.body);
        });
      });

      var resizer = {
        /**
         * @description Unique identifier for the tool component.
         */
        name: "resizer",
        start: function (event) {
          if ($resizeElem && event.target === $resizeElem[0]) {
            initialX = event.pageX;
            resizing = true;
            this.component.element.classList.add("resizing");
            document.body.classList.add("resizing");
            Event.trigger("pb:resizer:start");
          }
        },

        stop: function (event) {
          if (resizing) {
            var ratio = $resizeElem.width() / containerWidth;

            var targetColumns = 4;

            if (ratio >= 0.9) {
              targetColumns = 12;
            } else if (ratio >= 0.666) {
              targetColumns = 8;
            } else if (ratio >= 0.5) {
              targetColumns = 6;
            }

            var changed = targetColumns !== this.component.columns;

            if (changed) {
              var row = this.component.row;
              row.resize(this.component, targetColumns);
              this.section.reflow();
            }

            resizing = false;
            this.component.element.classList.remove("resizing");
            document.body.classList.remove("resizing");
            this.setDimensions();
            // don't add to last element in row
            /***
           * if we don't add the resizer tool to some components,
           * need that logic here in addition to shouldload, e.g.
           * something like this:
          if (this.component.element.classList.contains("omega")) {
            this.removeListeners();
            this.removeElement();
          } else {
            this.setDimensions();
          }
          ***/
          }
          Event.trigger("pb:resizer:done");
        },

        dragging: function (event) {
          if (resizing) {
            var delta = event.pageX - initialX,
              newWidth = $resizeElem.width() + delta;
            initialX = event.pageX;
            if (newWidth > containerWidth) {
              newWidth = containerWidth;
            }
            // hard coding columns to 3 for now
            if (newWidth < containerWidth / 3) {
              newWidth = containerWidth / 3;
            }
            $resizeElem.width(newWidth);
          }
        },

        setDimensions: function () {
          //position and height and width of resize element based on component element
          if ($resizeElem) {
            var $element = jQuery(this.component.element),
              offset = $element.offset(),
              outlineWidthCSS = $element.css("outline-width"),
              outlineWidth = outlineWidthCSS ? Number(outlineWidthCSS.substring(0, outlineWidthCSS.length - 2)) * 2 : 0;

            $resizeElem.height($element.outerHeight() + outlineWidth);
            $resizeElem.width($element.outerWidth() + outlineWidth);
            $resizeElem.css({
              top: offset.top - outlineWidth / 2,
              left: offset.left - outlineWidth / 2,
            });
          }
        },

        shouldLoad: function (component) {
          component.section.createRows();
          if (component.row.notFull() && !component.element.classList.contains("omega")) {
            return true;
          } else {
            return false;
          }
        },

        createElement: function () {
          var resizeElem = document.createElement("div");
          resizeElem.classList.add("resizer");

          if (this.component.shared) {
            resizeElem.classList.add("shared");
          } else if (this.component.inherited) {
            resizeElem.classList.add("inherited");
          } else {
            resizeElem.classList.add("unique");
          }

          document.body.insertBefore(resizeElem, document.body.firstChild);
          $resizeElem = jQuery(resizeElem);
        },

        removeElement: function () {
          if ($resizeElem && jQuery(document.body).find($resizeElem).length > 0) {
            document.body.removeChild($resizeElem[0]);
            $resizeElem = null;
          }
        },

        removeListeners: function () {
          $body.off("mousedown", this.start.bound);
          $body.off("mouseup", this.stop.bound);
          $body.off("mousemove", this.dragging.bound);
          this.start.bound = null;
          this.stop.bound = null;
          this.dragging.bound = null;
        },

        addListeners: function () {
          //add to bound property so we can remove it in unbind
          this.start.bound = this.start.bind(this);
          $body.on("mousedown", this.start.bound);
          this.stop.bound = this.stop.bind(this);
          $body.on("mouseup", this.stop.bound);
          this.dragging.bound = this.dragging.bind(this);
          $body.on("mousemove", this.dragging.bound);
        },
        /**
         * @name bind
         * @description
         * Bind the different event listeners to the component, and also add in
         *  any extra functionality to manage the slideshow
         * @param {HTMLElement} component
         */
        bind: function (component) {
          var me = this;

          if (component.resizeable) {
            component.element.classList.add("component-resizeable");
          } else {
            return;
          }

          //used to calculate number of columns a component should
          //take up after dragging
          containerWidth = jQuery(this.component.element.parentNode).width();
          this.removeElement.bound = this.removeElement.bind(this);

          this.setDimensions.show = function () {
            if (!$resizeElem) {
              me.createElement();
              me.addListeners();
            }
            me.setDimensions();
          };

          this.setDimensions.hide = function () {
            if (resizing) {
              me.setDimensions();
            }
          };

          this.setDimensions.render = function () {
            me.setDimensions();
          };

          Event.on("pb:component:unload", this.removeElement.bound, this);
          Event.on("pb:sidebar:show", this.setDimensions.show, this);
          Event.on("pb:sidebar:hide", this.setDimensions.hide, this);
          Event.on("pb:component:render", this.setDimensions.render, this);
        },

        /**
         * @name bind
         * @description
         * Unbind the different event listeners to the component added during the
         *  initial bind step.
         * @param {HTMLElement} element
         */
        unbind: function (element) {
          if (!this.component.resizeable) {
            return;
          }

          this.component.element.classList.remove("component-resizeable");
          this.removeListeners();
          this.removeElement();
          Event.off(null, null, this);
          this.removeElement.bound = null;
          resizing = false;
        },
      };
      return resizer;
    })(),
  );
})(Sparkle.PageBuilder.Helpers.Event);
